import { Directive, InjectionToken, Self, Inject, Input, OnInit } from '@angular/core';

export const FIELD_DATA = new InjectionToken<any>('FIELD_DATA');

@Directive({
  selector: '[stpFieldData]',
  providers: [
    {
      provide: FIELD_DATA,
      useValue: { }
    }
  ]
})
export class FieldDataDirective implements OnInit {
  @Input() stpFieldData: any;

  constructor(@Self() @Inject(FIELD_DATA) private fieldData: any) {
  }

  ngOnInit() {
    Object.assign(this.fieldData, this.stpFieldData);
  }
}
